var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#D52C51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 35.7143L64.2857 30L50 44.2857L35.7143 30L30 35.7143L44.2857 50L30 64.2857L35.7143 70L50 55.7143L64.2857 70L70 64.2857L55.7143 50L70 35.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorX);
export default __webpack_public_path__ + "static/media/error-x.402179454884d516301c7b2c90c2a7fe.svg";
export { ForwardRef as ReactComponent };